export class State {
  id: number;
  name: string;
  initials: string;

  constructor(attrs?: Partial<State>) {
    Object.assign(this, attrs);
  }
}
